<template>
  <!-- 离职  -->
  <div class="formBox">
    <!--员工基本信息 -->
    <FormTitle titleText="基本信息"/>
    <Form :disabled="load" ref="formValidate" :model="formItem" :rules="exitValidate" :label-width="150" label-position="left" >
      <div style="margin-bottom: 15px" class="rowAllBox">
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="姓名" >
              <Input placeholder="" v-model="formItem.userName">
                <Button slot="append" icon="ios-search" @click="open"></Button>
              </Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="主要职位">
              <Input disabled v-model="formItem.positionName"></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="入职日期">
              <Input disabled v-model="formItem.hirevalid" />
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="手机">
              <Input disabled v-model="formItem.mobile" />
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="离职日期" prop="last_working_date">
              <DatePicker
                type="date"
                style="width: 100%"
                v-model="formItem.last_working_date"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="离职原因" prop="quit_reason">
              <Select clearable v-model="formItem.quit_reason" placeholder="">
                <Option
                  v-for="(item, index) in Exit_Reason"
                  :value="item.code"
                  :key="index"
                  >{{ item.name }}
                </Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="是否有离职补偿金" prop="whether_severance">
              <Select clearable v-model="formItem.whether_severance" placeholder="">
                <Option v-for="(item, index) in Severance_Payment" :value="item.code" :key="index">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="离职补偿金总金额" v-if="isLZY" :prop="formItem.whether_severance == 1 ? 'amount_severance' : ''">
              <Input
                type="number"
                :disabled="isLZN"
                v-model="formItem.amount_severance"
              ></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="是否有重新雇佣资格" prop="eligible_rehire_hrbp">
              <Select clearable v-model="formItem.eligible_rehire_hrbp" placeholder="">
                <Option
                  v-for="(item, index) in Qulified_To_Rehire"
                  :value="item.code"
                  :key="index"
                  >{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24" class="rowBox">
            <FormItem :label="$t('离职补偿金附件')" v-if="formItem.whether_severance=='1'">
              <!-- <j2-FileUP ref="file" v-if="!getQueryVariable('history')" @handleOK="fileSuc" @handleDel="fileDel" :file_type="{resourceType:''}"></j2-FileUP> -->
               <!-- <label v-if="getQueryVariable('history')" style="cursor:pointer"  @click="download()">{{formItem.sename}}</label>   -->
              <j2-FileUP ref="file1" :disabled="getQueryVariable('history')==1" @handleDel="fileDel" @handleOK="fileSuc" :file_type="{resourceType:'Exit_Severance_Attachment_Hrbp'}" :resourceId="formItem.severance_attachment_hrbp"></j2-FileUP>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="当年度未休年假折算方式">
              <Select clearable :disabled="isLZN" v-model="formItem.annual_leave_conversion_way" placeholder="">
                <Option
                  v-for="(item, index) in ConversionWay"
                  :value="item.code"
                  :key="index"
                  >{{ item.ch_value }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="未休年假补偿金额">
              <Input type="number" :disabled="isLZN" v-model="formItem.unused_annual_leavel_compensation_amount"></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="当年度Retention Bonus是否包含在离职补偿金总金额">
              <Select :disabled="isLZN" clearable v-model="formItem.retention_bonus_severance" placeholder="">
                <Option v-for="(item, index) in Retention_Bonus_Included" :value="item.code" :key="index">{{ item.name }}</Option >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="space-between">
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="代通知金">
              <Input type="number" v-model="formItem.payment_lieu_notice"></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="一次性伤残补助金">
              <Input type="number" v-model="formItem.one_time_disability_allowance"></Input>
            </FormItem>
          </Col>
          <Col span="7" :xs="24" :sm="24" :md="24" :lg="7">
            <FormItem label="医疗补助费">
              <Input type="number" v-model="formItem.medicaid"></Input>
            </FormItem>
          </Col>
        </Row>
      </div>
    </Form>

    <!-- 保存和提交 -->
    <div class="btnRight">
      <Button class="applyBtnRight" v-if="!getQueryVariable('history')" @click="importCG">导入草稿</Button>
      <Button class="applyBtnRight" v-if="!getQueryVariable('history')" @click="saveCG">保存草稿</Button>
      <Button :disabled="prevent" v-if="!getQueryVariable('history')" class="applyBtnRight" type="primary" @click="comf">提交</Button>
      <Button :disabled="prevent" class="applyBtnRight" type="primary" @click="returnPage()">返回</Button>
    </div>
    <Modal v-model="empoloyee" title="选择员工" width="880px">
      <Form :model="formInline" inline :label-width="50" label-position="left">
        <FormItem label="员工姓名：" :label-width="120">
          <Input type="text" v-model="formInline.userName" placeholder="" style="width: 150px"></Input>
        </FormItem>
        <FormItem label="员工工号：" :label-width="120">
          <Input type="text" v-model="formInline.empCode" placeholder="" style="width: 150px"></Input>
        </FormItem>
        <Button type="primary" @click="(total = 0), (pageInfo.pageNo = 1), getp()">查询</Button>
      </Form>
      <Table border ref="myTable" :loading="loading" :columns="columns2" :data="data1">
        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="select1(row, index)">选择</Button>
        </template>
      </Table>
      <Page style="margin-top: 20px; text-align: right" :total="total" @on-change="pageChange"/>
      <div slot="footer"></div>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <div v-if="getQueryVariable('history')">
      <!-- 审批历史 -->
      <FormTitle titleText="审批历史" style="margin-top: 30px" />
      <Table border :columns="columns3" :data="data4" class="titleDistance">
      </Table>
    </div>
    <!-- 草稿模板列表 -->
    <j2-DraftTemplate ref="cgTem" @getCGDa="getCGDa1"/>
    <j2-DraftPop ref="cgPop"/>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "../../../util/DateUtil";
export default {
  data() {
    return {
      Ebeshow: 0,
      Qbeshow: 0,
      Sbeshow: 0,
      spinShow: false,
      // 工伤登记下拉框
      InjuryLv: [],
      //  当前年度未休假折算方式
      ConversionWay: [
        {
          code : '1',
          ch_value : "包含在离职补偿金"
        },
        {
          code : '0',
          ch_value : "不包含在离职补偿金"
        }
      ],
      // 申请成功时接收返回的instrance_id
      instanid: "",
      loading: false,
      prevent: false,
      load: false,
      isLZN: false,
      isLZY: true,
      //master
      master: [],
      date: new DateUtil(),
      empoloyee: false,
      //是否有离职补偿金
      Severance_Payment: [
      ],
      //当年度Retention_Bonus_Included
      Retention_Bonus_Included: [
      ],
      //是否有Rehire资格
      Qulified_To_Rehire: [
      ],
      //离职原因
      Exit_Reason: [
      ],
      formItem: {
        userName: "",
        injury_grade: "",
        last_working_date: "",
        quit_reasonL: "",
        whether_severance: "",
        amount_severance: "",
        eligible_rehire_hrbp: "",
      },
      formInline: {},
      jingyexieyi: false,
      //组织信息表格
      userOrgInfoData: {},
      data1: [],
      // 附件事项备注
      matter: {},
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      data3: [],
      data4:[],
      resourceId_List: [],
      Legal_Entity: [],
      instanceId:""
    };
  },
  computed: {
    exitValidate() {
      return {
        whether_severance: [
          { required: true, message: "请选择是否有离职补偿金" },
        ],
        eligible_rehire_hrbp: [
          { required: true, message: "请选择是否有重新雇佣资格" },
        ],
        quit_reason: [{ required: true, message: "离职原因不能为空" }],
        last_working_date: [{ required: true, message: "离职日期不能为空" }],
        amount_severance: [
          { required: true, message: "请输入离职补偿金总金额" },
        ],
      };
    },
    columns3(){
      return [
        {
          title: this.$t('审批流名称'),
          key: "stepName",
          align: "center",
          width:"280",
        },
        {
          title: this.$t('实际审批者'),
          key: "userName",
          align: "center",
          width:"280",
        },
        {
          title: this.$t('审批时间'),
          key: "time",
          align: "center",
          width:"280",
          render: (h, params) => {
                    return h(
                    "span",
                    this.date.dateVal(params.row.time, "YYYY-MM-DD HH:mm")
                    );
                },
        },
        {
          title: this.$t('审批状态'),
          key: "status",
          align: "center",
          width:"280",
          render: (h, params) => {
                    return h(
                    "span",
                    params.row.status == "0" ? "通过" : params.row.status == "1" ? "驳回" : ""
                    );
                },
        },
        {
          title: this.$t('审批意见'),
          key: "message",
          align: "center",
          width:"435",
        },
      ]
  },
    columns2() {
      return [
        {
          title: "操作",
          slot: "action",
          width: 100,
          align: "center",
        },
        {
          title: "员工工号",
          key: "empCode",
          align: "center",
        },
        {
          title: "员工姓名",
          key: "userName",
          align: "center",
        },
      ];
    },
  },
  created() {
    this.getp()
    console.log(this.getQueryVariable("history")==1)
    if(this.getQueryVariable("history")==1){
      this.getApprovalInfo()
      this.load=true
    }
  },
  watch: {
    "formItem.whether_severance"(val) {
      this.isLZY = false;
      this.isLZN = false;
      if (val == 2) {
        this.isLZN = true;
        this.formItem.amount_severance = "";
      }
      this.$nextTick(() => {
        this.isLZY = true;
      });
    },
  },
  methods: {
   importCG() {
      this.$refs.cgTem.getInternation()
      //草稿type 操作人
      this.$refs.cgTem.popShow('EX01',JSON.parse(sessionStorage.getItem('userInfo')).userId)
    },
    //保存草稿
    saveCG() {
      this.$refs.cgPop.getInternation()
      //草稿type 草稿内容
      this.formItem.last_working_date ? this.formItem.last_working_date  = this.date.dateVal(this.formItem.last_working_date, "YYYY-MM-DD") : null
      if(this.$refs.file1 && this.$refs.file1.fileName != null){
        this.formItem.severance_attachment_hrbp_name = this.$refs.file1.fileName
      }
      this.$refs.cgPop.popShow('EX01',{formItem: this.formItem,contractFormItem:this.contractFormItem,RecordData: this.RecordData})
    },
    //导入草稿数据到页面
    getCGDa1(row) {
      this.spinShow = true
      this.getp()
      var obj = JSON.parse(row.draftContent)
      this.formItem = obj.formItem
      this.$nextTick(() => {
        this.$refs.file1.resource_id = this.formItem.severance_attachment_hrbp
        this.$refs.file1.fileName = this.formItem.severance_attachment_hrbp_name
        setTimeout(()=>{
          this.spinShow =false
        },1000)
      })
    },
    download() {
      this.$donwLoad(this.formItem.severance_attachment_hrbp);
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getp();
    },
    // 删除附件
    fileDel(res_id) {
      this.formItem.severance_attachment_hrbp = "";
      this.resourceId_List.push(res_id);
    },
    // 离职补偿金附件、
    fileSuc(res_id) {
      console.log(res_id)
      this.formItem.severance_attachment_hrbp = res_id;
    },
    returnPage() {
      //1审批 0 申请
      if (this.getQueryVariable("history") == 1) {
        this.$router.push("/EE8D3DF28FEFA1026138E1506FB19594/A3FFBEBFDB713E27");
      } else {
        this.$router.go(-1);
      }
    },
    open() {
      this.empoloyee = true;
    },
    select1(row, index) {
      this.selectone(row);
      this.empoloyee = false;
    },
    selectone(row) {
      this.formItem = row
    },
    getp() {
      // 获取申请人信息
      this.loading = true;
      let Obj = {
        userName : this.formInline.userName,
        empCode : this.formInline.empCode,
        pageNo:this.pageInfo.pageNo,
        pageSize:this.pageInfo.pageSize,
        optionName:['YESORNO','QUITREASON'] 
      }
      axios.post("/Exit/selectEmployeeInfo", Obj).then((res) => {
        this.data1 = res.data
        this.Severance_Payment = res.optionData.YESORNO
        this.Retention_Bonus_Included=res.optionData.YESORNO
        this. Qulified_To_Rehire=res.optionData.YESORNO
        this.Exit_Reason=res.optionData.QUITREASON
        for(let i=0;i<this.data1.length;i++){
          this.data1[i].hirevalid ? this.data1[i].hirevalid = this.date.dateVal(this.data1[i].hirevalid,"YYYY-MM-DD") : '' 
        }
        this.total = parseInt(res.pageInfo.total)
        this.loading = false;
      });
    },
    handleComfirm() {
      this.prevent = true;
      this.load = true;
      this.formItem.last_working_date ? this.formItem.last_working_date  = this.date.dateVal(this.formItem.last_working_date, "YYYY-MM-DD") : ''
      let arr = 
         [{
          objData1:{
            serialnumber:this.formItem.serialnumber,
            title_position : this.formItem.positionName,
            user_name : this.formItem.userName,
            apply_user_id:JSON.parse(window.sessionStorage.getItem("userInfo")).userId, 
            apply_serialnumber:JSON.parse(window.sessionStorage.getItem("userInfo")).serialnumber, 
            apply_name:JSON.parse(window.sessionStorage.getItem("userInfo")).userName,
            ...this.formItem
          },
          stringData1: "EX01",
          type: "B31",
        }];
      this.spinShow = true;
      axios.post("/process/execute", arr).then((res) => {
        if (res) {
          if (this.resourceId_List.length > 0) {
            this.$removeFile(this.resourceId_List);
          }
          let Obj ={
            instanceId : res[0]
          }
          axios.post("/Exit/insertExitMatter", Obj).then((res) => {
              console.log(res);
          })
          this.$Message.success("离职申请成功");
          this.$router.push("/479EB7C68FD1C711E1668077E8206CA1/A3FFBEBFDB713E27");
        }
        this.spinShow = false;
        this.prevent = false;
        this.load = false;
      });
    },
    comf() {
      let flag = false;
      this.$refs["formValidate"].validate((valid) => {
        if (!valid) {
          flag = true;
        }
      });
      if (flag) {
        this.$Message.error("请填写必填项");
        return;
      }
      console.log(this.formItem.severance_attachment_hrbp);
      if (
        this.formItem.whether_severance == 1 &&
        !this.formItem.severance_attachment_hrbp
      ) {
        this.$Message.error("请上传离职补偿金附件");
        return;
      }
      this.$Modal.confirm({
        title: this.$notice('submission'),
        content: "",
        onOk: () => {
          this.handleComfirm();
        },
        onCancel: () => {},
      });
    },
    getApprovalInfo(){
      let Obj={
        instanceId : this.getQueryVariable("instanceId")
      }
      axios.post("/Exit/selectExitApprovalInfo", Obj).then((res) => {
          this.formItem=res.basicInfo
          this.formItem.hirevalid ? this.formItem.hirevalid= this.date.dateVal(this.formItem.hirevalid,"YYYY-MM-DD") : '' 
          this.data4=res.logMap
          this.Severance_Payment= res.YESORNO
          this.Retention_Bonus_Included= res.YESORNO
          this.Qulified_To_Rehire= res.YESORNO
          this.Exit_Reason=res.QUITREASON
          this.$nextTick(() => {
            this.getFileNameAndID();
          });
          this.$set(this.formItem,'positionName',this.formItem.title_position)
      });
    },
    getFileNameAndID(){
            this.$refs.file1 ? this.$refs.file1.resource_id = this.formItem.severance_attachment_hrbp : '';
            this.$refs.file1 ? this.$refs.file1.fileName = this.formItem.resource_name : '';
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.formBox {
  width: 97%;
  margin: auto;
  background: white;
  padding-bottom: 30px;
  border-radius: 10px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.rowBox {
  line-height: 35px;
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}
.rowAllBox {
  width: 97%;
  margin: auto;
}
.width {
  width: 180px;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/ExitApply.vue